import ns from '../../../../core/script/api/utilities/namespace.js';

const TooltipEvent = {
  SHOW: ns.event('show'),
  HIDE: ns.event('hide')
};

export { TooltipEvent };
